export default __webpack_public_path__ + "static/assets/e4dfc45f34b4606356c4c70ba14a96f0.svg";